import { render, staticRenderFns } from "./OrderDetailSupply.vue?vue&type=template&id=65ba4226"
import script from "./OrderDetailSupply.vue?vue&type=script&lang=js"
export * from "./OrderDetailSupply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports